<template>
  <div class="Action-form Action-form--group">
    <div class="Action-form__input Action-form__input--group-affiliation">
      <div v-if="isPositive" class="Action-form__input__inputs">
        <TextInput
          class="Form-input__item"
          label="Koncernnamn"
          :disabled="isDisabled"
          @input="updateGroupAffiliationData($event, 'companyName')"
          @blur="doUpdateGroupAffiliation"
          type="text"
          placeholder="Ange koncernnamn"
          :validation="$v.action.group.companyName"
          v-model.lazy="action.group.companyName"
        />
        {{ /* :validation="$v.companyName" */ }}
        <TextInput
          class="Form-input__item"
          label="Organisationsnummer (XXXXXX-XXXX)"
          :disabled="isDisabled"
          @input="updateGroupAffiliationData($event, 'organizationNumber')"
          @blur="doUpdateGroupAffiliation"
          type="text"
          placeholder="Ange organisationsnummer"
          :validation="$v.action.group.organizationNumber"
          v-model="action.group.organizationNumber"
          :maxLength="11"
        />
        <!-- {{ validation="$v.organizationNumber" }} -->
      </div>
      <div v-if="!isApplicant" class="Action-form__controls">
        <ToggleInput :value="approved" :disabled="!action.isValid || !isDisabled" text="Godkänt krav" @input="handleChangeApproved" />
        <div v-if="!approved">
          <button
            v-if="submitted"
            class="Button Button--secondary"
            @click="unlockAction">Lås upp för komplettering
          </button>
          <button
            v-else
            class="Button Button--primary"
            @click="lockAction">Avsluta komplettering
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import TextInput from '@/components/forms/TextInput'
import ToggleInput from '@/components/forms/ToggleInput'
import { required } from 'vuelidate/lib/validators'
import { EventBus } from '@/services/event-bus'
import { isValidOrgNo } from 'se-org-no'
import { getOrgFormat } from '@/utils/string-helpers'

export default {
  name: 'ApplicationActionMetaGroupAffiliation',
  components: { TextInput, ToggleInput },
  props: {
    action: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isPositive: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
    }
  },
  validations: {
    action: {
      group: {
        companyName: {
          required
        },
        organizationNumber: {
          required,
          orgNo: (value) => {
            return isValidOrgNo(value)
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('memberStore', ['isApplicant']),
    approved () {
      return this.action.status === 'APPROVED'
    },
    submitted () {
      return this.action.status === 'IN_REVIEW'
    },
    isDisabled () {
      return this.submitted || this.approved
    }
  },
  watch: {
    '$v.$anyError': function () {
      EventBus.$emit('expander:resize')
    }
  },
  methods: {
    ...mapActions('applicationStore', ['approveAction', 'updateGroupAffiliation', 'submitAction']),
    ...mapState('applicationStore', ['application']),
    updateGroupAffiliationData (value, field) {
      this.action.group.companyName = field === 'companyName' ? value : this.action.group.companyName
      this.action.group.organizationNumber = field === 'organizationNumber' ? getOrgFormat(value) : this.action.group.organizationNumber
    },
    doUpdateGroupAffiliation () {
      this.updateGroupAffiliation({
        actionId: this.action.id,
        data: {
          actionIsPositive: true,
          companyName: this.action.group.companyName,
          organizationNumber: this.action.group.organizationNumber
        }
      })
    },
    // submit(isClicked) {
    //   this.submitAction({
    //     actionId: this.action.id,
    //     submitted: isClicked
    //   })
    // },
    handleChangeApproved (isChecked) {
      this.approveAction({
        actionId: this.action.id,
        approved: isChecked
      })
    },
    unlockAction () {
      this.submitAction({
        actionId: this.action.id,
        submitted: false
      })
    },
    lockAction () {
      this.submitAction({
        actionId: this.action.id,
        submitted: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
